/**
 * External reports and data sources listed in the Community Strength section.
 *
 * `num` is the translation key number — the card's title and description come
 * from `community.report<num>.title` / `.description` so both languages stay
 * in sync. Order here is the order shown on the page.
 */
export const HONDURAS_REPORTS: { num: number; url: string }[] = [
  {
    num: 1,
    url: 'https://data.census.gov/table/ACSSPP1Y2024.S0201?q=honduran',
  },
  {
    num: 20,
    url: 'https://budgetmodel.wharton.upenn.edu/p/2025-11-19-550-000-workers-lose-status-by-end-of-2025/',
  },
  {
    num: 21,
    url: 'https://www.fwd.us/news/temporary-protected-status-report-2025/',
  },
  {
    num: 6,
    url: 'https://www.pewresearch.org/hispanic/fact-sheet/us-hispanics-facts-on-honduran-origin-latinos/',
  },
  {
    num: 4,
    url: 'https://www.migrationpolicy.org/country-resource/honduras',
  },
  {
    num: 5,
    url: 'https://www.migrationpolicy.org/data/unauthorized-immigrant-population/state/US',
  },
  {
    num: 17,
    url: 'https://sfo2.digitaloceanspaces.com/itep/ITEP-Tax-Payments-by-Undocumented-Immigrants-2024.pdf',
  },
  {
    num: 18,
    url: 'https://www.brookings.edu/articles/climate-violence-and-honduran-migration-to-the-united-states/',
  },
  {
    num: 19,
    url: 'https://www.everycrsreport.com/files/2023-11-30_R47856_509b38f111c97e00b36f10716d1716a033b17287.pdf',
  },
  {
    num: 2,
    url: 'https://www.worldbank.org/en/country/honduras/overview',
  },
  {
    num: 23,
    url: 'https://documents1.worldbank.org/curated/en/099150301182319439/pdf/BOSIB-e1e1992b-5d61-4827-a3c4-36175086d671.pdf',
  },
  {
    num: 3,
    url: 'https://hdr.undp.org/data-center/specific-country-data#/countries/HND',
  },
  {
    num: 7,
    url: 'https://www.iadb.org/en/who-we-are/country-offices/honduras',
  },
  {
    num: 8,
    url: 'https://crisisresponse.iom.int/response/honduras-crisis-response-plan-2023-2025',
  },
  {
    num: 9,
    url: 'https://www.asj-us.org/stories',
  },
  {
    num: 10,
    url: 'https://www.hrw.org/world-report/2026/country-chapters/honduras',
  },
  {
    num: 11,
    url: 'https://statistics.cepal.org/portal/cepalstat/index.html?lang=en',
  },
  {
    num: 12,
    url: 'https://freedomhouse.org/country/honduras/freedom-world/2025',
  },
  {
    num: 13,
    url: 'https://www.unocha.org/publications/report/honduras/honduras-humanitarian-needs-and-response-plan-2025-summary',
  },
  {
    num: 14,
    url: 'https://reliefweb.int/report/honduras/wfp-honduras-country-brief-october-2025',
  },
  {
    num: 15,
    url: 'https://reliefweb.int/report/honduras/honduras-necesidades-humanitarias-remanentes-enero-2026',
  },
  {
    num: 16,
    url: 'https://open.unicef.org/country/Honduras?cid=1860',
  },
  {
    num: 22,
    url: 'https://inm.gob.hn/retornados.html',
  },
]

/** Translation key numbers for the Honduras quick-facts grid. */
export const HONDURAS_FACT_NUMBERS: number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
]
